import { getDashboardTourSteps } from "./dashboardTour";
import { getReportsTourSteps } from "./reportsTour";
import { getSettingTourSteps } from "./settingTour";
import { getShiftAndRosterTourSteps } from "./ShiftAndRosterTour";
import { getUserGroupTourSteps } from "./userGroupTour";
import {
  getUserManagementTourSteps,
  getUserManagementEmployeeTourSteps,
} from "./userManagementTour";
// import thêm các tab khác sau

export const TOUR_REGISTRY = {
  dashboard: getDashboardTourSteps,
  "user-management": getUserManagementTourSteps,
  "user-groups-management": getUserGroupTourSteps,
  settings: getSettingTourSteps,
  reports: getReportsTourSteps,
  "shift-and-roster-management": getShiftAndRosterTourSteps,
  // "devices-management": getDevicesTourSteps,
};

export const getTourStepsByPage = (pageName, t, options = {}) => {
  const { isAdmin = true } = options;

  if (pageName === "user-management" && !isAdmin) {
    return getUserManagementEmployeeTourSteps(t);
  }

  if (pageName === "shift-and-roster-management") {
    return getShiftAndRosterTourSteps(t, { isAdmin });
  }

  const factory = TOUR_REGISTRY[pageName];
  return factory ? factory(t) : [];
};
